module.exports = __webpack_public_path__ + "img/dapps-active.19387e9d.svg";